import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getDineAroundFormatByType } from '../../dineAround/dineAroundHelper';
import '../entertainmentOption/EntertainmentOption.scss';

const getNoSpacesMessage = (areSpacesAvailable) => {
  if (!areSpacesAvailable) return 'SOLD OUT';
  return 'No spaces available';
};

const DineAroundOption = ({
  label = '',
  checked = false,
  color = '',
  areSpacesAvailable = true,
  disabled,
  onOptionClick,
  isAlreadyBooked,
  dineAroundType,
  isAlreadyBookedOnThisDay = false,
  isAllowedToBookDABasedOnCutoff,
}) => (
  <div
    className={classnames('option', checked && 'checked', color && color, disabled && 'grey-background')}
    onClick={onOptionClick}
  >
    {!!label && <div className="option-label">{label}</div>}
    {!checked && isAlreadyBookedOnThisDay && areSpacesAvailable && (
      <div className="option-no-spaces">
        {`${getDineAroundFormatByType(dineAroundType)} already booked for this day`}
      </div>
    )}
    {!checked && !areSpacesAvailable && !isAlreadyBooked && (
      <div className="option-no-spaces">
        {getNoSpacesMessage(areSpacesAvailable)}
      </div>
    )}
    {!checked && areSpacesAvailable && !isAlreadyBooked && !isAllowedToBookDABasedOnCutoff && (
      <div className="option-no-spaces da-cutoff">
        The booking window for this has closed. If you still need to book, please pop along to the venue to check availability
      </div>
    )}
  </div>
);

DineAroundOption.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onOptionClick: PropTypes.func.isRequired,
  areSpacesAvailable: PropTypes.bool,
  isAlreadyBooked: PropTypes.bool,
  dineAroundType: PropTypes.string,
  isAlreadyBookedOnThisDay: PropTypes.bool,
  isAllowedToBookDABasedOnCutoff: PropTypes.bool,
};

export default DineAroundOption;
